export const SHOW_NO_SHOW_MODAL = 'SHOW_NO_SHOW_MODAL'
export const MARK_PARTICIPANT_AS_NO_SHOW_SUCCEEDED = 'MARK_PARTICIPANT_AS_NO_SHOW_SUCCEEDED'
export const MARK_PARTICIPANT_AS_NO_SHOW_REQUESTED = 'MARK_PARTICIPANT_AS_NO_SHOW_REQUESTED'
export const CHECK_FOR_NO_SHOWS = 'CHECK_FOR_NO_SHOWS'